import { BitkitLink } from '@bitrise/bitkit-v2';
import { ReactNode } from 'react';

// RegExp constructor form: named groups in a regex literal require an ES2018+ tsconfig target.
const MarkdownLinkRegexp = new RegExp('\\[(?<desc>.+?)\\]\\((?<href>.+?)\\)', 'g');

const linkifyMarkdown = (content: string): ReactNode | ReactNode[] => {
  const matches = [...content.matchAll(MarkdownLinkRegexp)];

  if (matches.length === 0) {
    return content;
  }

  let lastIndex = 0;
  const fragments: ReactNode[] = [];
  matches.forEach((match) => {
    // Extract text until the beginning of the next match
    fragments.push(content.slice(lastIndex, match.index));

    // Linkify extracted link regexp groups
    fragments.push(
      <BitkitLink href={match.groups?.href} textDecoration="underline" isExternal>
        {match.groups?.desc}
      </BitkitLink>,
    );

    // Advance processed text index pointer
    lastIndex = (match.index || 0) + match[0].length;
  });

  // Extract text after the last match
  if (lastIndex !== content.length) {
    fragments.push(content.slice(lastIndex));
  }

  return fragments.filter((f) => f);
};

export default linkifyMarkdown;
